import React, {Component} from "react";
import PropTypes from "prop-types";

import {cloneDeep, remove} from "lodash";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons';

import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';

import {
    Input,
    Spinner,
    Dropdown,
    DropdownMenu,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";
//classes

class AddressField extends Component {
    debug = false;
    blurTimeout = {};
    state = {
        hasFocus: false
    };
    
    constructor( props ){
        super( props );
    }
    
    handleSelect = ( address ) => {
        const {
            map,
            onChange,
        } = this.props;
        
        geocodeByAddress(address).then(results => {
            const address = results[0] ?? {};
            const components = address.address_components ?? {};
            
            let elements = {
                subnumber: '',
                number: '',
                street: '',
                suburb: '',
                state: '',
                postcode: '',
            };
            components.forEach( elm => {
                if( elm.types.includes('subpremise') ){
                    elements.subnumber = elm.long_name;
                } else if( elm.types.includes('street_number') ){
                    elements.number = elm.long_name;
                } else if( elm.types.includes('route') ){
                    elements.street = elm.long_name;
                } else if( elm.types.includes('locality') ){
                    elements.suburb = elm.long_name;
                } else if( elm.types.includes('administrative_area_level_1') ){
                    elements.state = elm.short_name;
                } else if( elm.types.includes('postal_code') ){
                    elements.postcode = elm.short_name;
                }
            } )
            if( this.debug ) console.log('Geocoded: ',results[0], elements);
            
            if( this.debug ) console.log('Address field map: ',map);
            // Set other inputs based on Input Map
            let newValues = {};
            for (const src in map) {
                const fld = map[src];
                if( elements[src] ){
                    newValues[fld] = elements[src];
                }
            }
            if( this.debug ) console.log('Address field - New Values: ',newValues);
            
            // Set this input to number + ' ' + street
            onChange( elements.number + ' ' + elements.street, newValues );
        });
        if( this.debug ) console.log('Address selected: ',address);
    };
    
    render(){
        const {
            fldId,
            value,
            placeholder,
            className,
            onChange,
            error,
            errorText,
            readonly,
            helperText,
            templateFn,
        } = this.props;
        
        const {
            hasFocus,
        } = this.state;
        
        let wrapperClass = className;
        let fldClass = '';
        if( error ){
            wrapperClass += ' fld-error';
            if(this.debug) console.log('FIELD ERROR!!!!!!!', fldId);
        }
        if( readonly ){
            fldClass += ' form-control-muted';
        }
        
        let parsedDesc = helperText ?? '';
        if( '' != parsedDesc ){
            parsedDesc = parsedDesc.replace(/\${_([\w_-]+)}/g, templateFn);
            if( this.debug ) console.log('Parsed Desc: ', parsedDesc);
        }
        
        let errorMsg = errorText ?? 'Field invalid. Please check your input.';
        
        const searchOptions = {
            componentRestrictions: {
                country: 'au',
            },
            region: 'au',
            types: ['address']
        }
        
        return (
            <PlacesAutocomplete
                id={'meta_'+fldId}
                value={value}
                onChange={(e)=>{
                    onChange( e );
                }}
                onSelect={this.handleSelect}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
                    if( this.debug ) console.log('Places results: ',suggestions, loading);
                    if( this.debug ) console.log('Is open: ',(hasFocus&&(suggestions.length||loading)));
                    return (
                        <Dropdown
                            direction="down"
                            isOpen={hasFocus&&(suggestions.length||loading)}
                            className="adressField"
                            onFocus={e=>{
                                clearTimeout(this.blurTimeout);
                                if( this.debug ) console.log('Address field has focus');
                                this.setState({hasFocus:true});
                            }}
                            onBlur={e=>{
                                clearTimeout(this.blurTimeout);
                                this.blurTimeout = setTimeout( e=>{
                                    if( this.debug ) console.log('Address field lost focus');
                                    this.setState({hasFocus:false});
                                }, 600 );
                            }}
                        >
                            {(helperText) ? (
                                <p className="fld-description">{parsedDesc}</p>
                            ) : (null)}
                            <InputGroup className={wrapperClass}>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText className={fldClass}>
                                        <FontAwesomeIcon className="inputIcon" icon={faBuilding} />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <input
                                    {...getInputProps({
                                        placeholder: 'Enter Address ...',
                                        className: fldClass + ' location-search-input form-control',
                                    })}
                                />
                            </InputGroup>
                            {(error) ? (
                                <p className="fld-errormsg fld-description">{errorMsg}</p>
                            ) : (null)}
                            
                            <DropdownMenu>
                                {loading ? (
                                    <div className="text-center">
                                		<Spinner color="primary" />
                                	</div>
                                ) : null}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style,
                                            })}
                                        >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </DropdownMenu>
                        </Dropdown>
                    );
                }}
            </PlacesAutocomplete>
        );
    
      // return (
      //           <Input
      //               id={'meta_'+fldId}
      //               type="text"
      //               value={value}
      //               placeholder={placeholder}
      //               onChange={(e)=>{
      //                   onChange( e.target.value );
      //               }}
      //               autocomplete="off"
      //               invalid={error}
      //               className={fldClass}
      //           />
      //   );
    }
}

AddressField.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    placeholder: PropTypes.string,
    readonly: PropTypes.bool,
    map: PropTypes.object,
    error: PropTypes.bool,
    onChange: PropTypes.func
};

AddressField.defaultProps = {
    fldId: null,
    value: null,
    placeholder: null,
    readonly: null,
    map: {},
    error: false,
    onChange: (newVal) => {console.log('Field value updated',newVal)}
}

export default AddressField;
